import type { ColumnDef } from "@tanstack/react-table";
import { Badge } from "@volca/ui/components/ui/badge";
import { Stack } from "@volca/ui/components/ui/stack";
import { Text } from "@volca/ui/components/ui/text";
import type {
  AccountTableUser,
  WorkbookAccessColumnSettings,
} from "@/business-settings/users/web-app-users/users-table/types";
import { getAccessSummary } from "@/business-settings/users/workbook-access/access-summary";

export const WorkbookAccessCol = ({
  settings,
}: WorkbookAccessColumnSettings): ColumnDef<AccountTableUser> => ({
  id: "workbook_access",
  header: "Workbook access",
  enableSorting: false,
  cell: ({ row }) => {
    const summary = getAccessSummary(settings, row.original.id);
    if (summary.empty) return <Text tone="muted">No access</Text>;
    return (
      <Stack gap={1} className="max-w-full min-w-0" title={summary.detail}>
        <Stack direction="row" align="center" gap={1} className="min-w-0">
          <Badge
            variant="secondary"
            color={summary.full ? "blue" : "neutral"}
            size="sm"
            className="max-w-full min-w-0"
          >
            <span className="truncate">{summary.scope}</span>
          </Badge>
          {summary.extraCount > 0 && (
            <Text variant="caption" tone="muted" className="shrink-0">
              +{summary.extraCount}
            </Text>
          )}
        </Stack>
        <Text variant="caption" tone="muted">
          {summary.rights}
        </Text>
      </Stack>
    );
  },
});
